export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Mexico-0337f67ff5ed36a563cf16459bf8c705.mp3";